/**
 * * Получить rect элемента
 * @param renderTemplate Строка которую необходимо отрендерить и получить DOMRect
 * @returns
 */
export const getElementRect = (renderTemplate: string): DOMRect => {
  const fragment = document.createDocumentFragment();
  const tempElement = document.createElement("div");
  tempElement.innerHTML = renderTemplate;
  fragment.appendChild(tempElement);

  const hiddenContainer = document.createElement("div");
  hiddenContainer.style.visibility = "hidden";
  hiddenContainer.style.position = "absolute";
  hiddenContainer.style.whiteSpace = "nowrap";
  hiddenContainer.style.maxWidth = "150px";
  hiddenContainer.appendChild(fragment);
  document.body.appendChild(hiddenContainer);
  const tagElement = tempElement.firstElementChild as HTMLElement;

  const rect = tagElement.getBoundingClientRect();
  document.body.removeChild(hiddenContainer);

  return rect;
};
